import React from "react";
import { OrderHistoryProps } from "../types/dashboard";
import OrderSummary from "./OrderSummary";
import { useUser } from "src/shared/context/UserContext";

const OrderHistory: React.FC<OrderHistoryProps> = ({ dashboardData = {}, businessType }) => {
  const { userConfigration } = useUser();
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString("default", { month: "short" });
  const currentYear = currentDate.getFullYear();

  const toBoolean = (value: any) => value === true || value === "true";
  const parcelFeeEnabled = toBoolean(userConfigration?.parcelFeeEnabled);
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);

  // Only show parcel fee and tips for Restaurant
  const showParcelFee = businessType === "Restaurant" && parcelFeeEnabled;
  const showTips = businessType === "Restaurant" && tipsEnabled;

  // Safely extract data
  const periodicDetails = dashboardData?.periodic_order_details || {};
  const monthlySummary = dashboardData?.calculate_monthly_summary || [];

  // Today's data
  const todayOrders = periodicDetails?.today?.totalOrders || 0;
  const todaySales = periodicDetails?.today?.totalSales || 0;
  const todayOutstanding = periodicDetails?.today?.totalOutstanding || 0;
  const todayReceived = periodicDetails?.today?.totalReceived || 0;
  const todayDeliveryFee = periodicDetails?.today?.totalDeliveryFee || 0;
  const todayDiscount = periodicDetails?.today?.combinedDiscount || 0;
  const todayParcelFee = showParcelFee ? (periodicDetails?.today?.totalParcelFee || 0) : 0;
  const todaytips = showTips ? (periodicDetails?.today?.totalTip || 0) : 0;

  // Weekly data
  const weekOrders = periodicDetails?.weekly?.totalOrders || 0;
  const weekSales = periodicDetails?.weekly?.totalSales || 0;
  const weekOutstanding = periodicDetails?.weekly?.totalOutstanding || 0;
  const weekReceived = periodicDetails?.weekly?.totalReceived || 0;
  const weekDeliveryFee = periodicDetails?.weekly?.totalDeliveryFee || 0;
  const weekDiscount = periodicDetails?.weekly?.combinedDiscount || 0;
  const weekParcelFee = showParcelFee ? (periodicDetails?.weekly?.totalParcelFee || 0) : 0;
  const weektips = showTips ? (periodicDetails?.weekly?.totalTip || 0) : 0;

  // Monthly data
  const currentMonthSummary = monthlySummary.find(
    (month) => month.month === currentMonth && month.year === currentYear
  );
  const monthOrders = currentMonthSummary?.order_count || 0;
  const monthReceived = currentMonthSummary?.total_received || 0;
  const monthOutstanding = currentMonthSummary?.total_outstanding || 0;
  const monthSales = currentMonthSummary?.total_sales || 0;
  const monthDeliveryFee = currentMonthSummary?.total_delivery_fee || 0;
  const monthDiscount = currentMonthSummary?.combined_discount || 0;
  const monthParcelFee = showParcelFee ? (currentMonthSummary?.total_parcel_fee || 0) : 0;
  const monthtips = showTips ? (currentMonthSummary?.total_tip || 0) : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 -mt-2 mb-3 w-full">
      <OrderSummary 
        title="Today's Orders" 
        timeRange="today" 
        orders={todayOrders} 
        amount={todaySales} 
        received={todayReceived} 
        outstanding={todayOutstanding} 
        DeliveryFee={todayDeliveryFee} 
        Discount={todayDiscount} 
        ParcelFee={todayParcelFee} 
        tips={todaytips} 
        businessType={businessType}
        showParcelFee={showParcelFee}
        showTips={showTips}
      />
      <OrderSummary 
        title="Last 7 Days Orders" 
        timeRange="week" 
        orders={weekOrders} 
        amount={weekSales} 
        received={weekReceived} 
        outstanding={weekOutstanding} 
        DeliveryFee={weekDeliveryFee} 
        Discount={weekDiscount} 
        ParcelFee={weekParcelFee} 
        tips={weektips} 
        businessType={businessType}
        showParcelFee={showParcelFee}
        showTips={showTips}
      />
      <OrderSummary 
        title="This Month's Orders" 
        timeRange="month" 
        orders={monthOrders} 
        amount={monthSales} 
        received={monthReceived} 
        outstanding={monthOutstanding} 
        DeliveryFee={monthDeliveryFee} 
        Discount={monthDiscount} 
        ParcelFee={monthParcelFee} 
        tips={monthtips} 
        businessType={businessType}
        showParcelFee={showParcelFee}
        showTips={showTips}
      />
    </div>
  );
};

export default OrderHistory;